export default __webpack_public_path__ + "static/ICCAM_04-5ead9d5e19bd0965d182481f4e42437f.webp";